
import './Assests/css/App.css';
import Home from './View/Home';
import Profile  from './View/Profile.js';
import  NavBar from './Components/Nav.js';
import Projects from './View/Projects.js';
import Hobbies from './View/Hobbies.js';
import Achievement from './View/Achievements.js';
import Footer from './Components/Footer.js';
function App() {
  return (
    <div className="App">
      <NavBar/>
      <Home/>
        <Profile/>
        <Achievement/>
        <Projects/>
        <Hobbies/>
        <Footer/>
    </div>
  );
}

export default App;
